import type { FaireBrandEntity } from "../../entity_types/brand";

export const brooklynCookieCo: FaireBrandEntity = {
  token: "brooklyn-cookie-co",
  type: "brand",
  name: "Brooklyn Cookie Co.",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/245d98016865b8aec5fec7bfb250bc895d0504ecc6ffcf92f49696f167a07840.webp",
  description: "Handcrafted cookies baked fresh daily",
  rating: 4.8,
  location: "Brooklyn, NY",
  minimumOrderDollars: 100,
  tags: ["handmade", "fresh", "cookies"],
  isInsider: false,
  categoryTokens: ["cat_food-snacks"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
